import axios from "axios";
import { ORDER_API } from "constants/apiUrls";


// 쿠폰 리스트 조회
export async function getCouponList(data) {
  try {
    if(data) {
      const response = await axios.get(`${ORDER_API}/aw/coupon/shop/admin`, {
        headers: {Authorization: `Bearer ceo`},
        params: data
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 상점 쿠폰 리스트 조회
export const getShopCouponListApi = async (data) => {
  try {
    if(data) {
      const response = await axios.get(`${ORDER_API}/coupon/ceo`, {
        headers: {Authorization: `Bearer ceo`},
        params: data
      });
      return response.data;
    }
  } catch (e) {
    console.log(e);
  }
}

// 쿠폰 등록
export const newCouponApi = async (data) => {
  await axios.post(`${ORDER_API}/aw/coupon`, data, {
    headers: {Authorization: `Bearer admin`}
  });
}

export const setCouponApi = async (id, data) => {
  await axios.put(`${ORDER_API}/aw/coupon/${id}`, data, {
    headers: {Authorization: `Bearer admin`}
  });
}


// 쿠폰 상세 조회
export async function getCouponDetail(id) {
  try {
    if(id) {
      const response = await axios.get(`${ORDER_API}/aw/coupon/detail/admin/${id}`, {
        headers: {Authorization: `Bearer admin`}
      });
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
}

// 쿠폰 삭제
export async function deleteCoupon(coupon) {
  
  if (Number(coupon.issuerType) === 1) {
    alert("본사에서 발행한 쿠폰은 삭제할 수 없습니다.");
    return false;
  }
  
  if (Number(coupon.status) === 1) {
    alert("진행중인 쿠폰은 삭제할 수 없습니다.");
    return false;
  }
  
  let result = window.confirm("삭제하시겠습니까?");
  if (result) {
    axios.delete(`${ORDER_API}/aw/coupon/${coupon.id}`, {
      headers: {
        Authorization: `Bearer admin`,
      }
    }).then(function() {
      window.location.href = "/v2/coupon";
    });
  }
}